import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import Logo3D from "@/components/Logo3D";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [loading, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Добро пожаловать");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Ошибка входа");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 overflow-hidden">
      <div className="absolute inset-0 grid-bg -z-10" />
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md p-6 sm:p-8 rounded-3xl border border-border bg-card glow-primary"
      >
        <div className="flex justify-center mb-6">
          <Logo3D size={48} />
        </div>
        <h1 className="font-heading text-2xl font-bold text-center mb-1">Админ-панель</h1>
        <p className="text-center text-sm text-muted-foreground mb-8">Войдите для управления TEMPEO</p>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-semibold text-muted-foreground mb-1.5 block">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 px-3 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-muted-foreground mb-1.5 block">Пароль</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-11 pl-10 pr-3 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                data-testid="admin-login-password"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full h-11 inline-flex items-center justify-center gap-2 rounded-full bg-foreground text-background font-semibold text-sm disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            <LogIn className="size-4" />
            {submitting ? "Вход..." : "Войти"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
